export default {
      id: "icon-social-youtube-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.svg#icon-social-youtube",
      toString: function () {
        return this.url;
      }
    }